module.exports = __webpack_public_path__ + "img/caseclub-logo.91cd1901.svg";